import { Grid } from '@mui/material';
import { ReactNode } from 'react';

export const DialogContainer = ({
  children,
  additionalSx,
}: {
  children: ReactNode;
  additionalSx?: object;
}) => {
  return (
    <Grid
      sx={[
        {
          display: 'flex',
          flexDirection: 'column',
          padding: '20px 40px 20px 40px',
        },
        additionalSx,
      ]}
    >
      {children}
    </Grid>
  );
};
